import styled, { css } from 'styled-components/macro';
import { PriceType } from '../../../hooks/api/queries/useProducts';
import { WImage } from './Image';

interface Props {
  price?: PriceType;
  position?: 'top' | 'bottom';
}

export const PriceImage = ({ price, position = 'bottom' }: Props) => {
  if (!price || !price.image.path) return null;
  return (
    <AbsolutePosition position={position}>
      <WImage image={price.image} />
    </AbsolutePosition>
  );
};

const AbsolutePosition = styled.div<{ position: string }>`
  position: absolute;
  z-index: 1;
  right: 0;
  img {
    aspect-ratio: unset !important;
  }

  ${({ position }) =>
    position === 'top'
      ? css`
          top: 0;
        `
      : css`
          bottom: 0;
        `};
`;
